module.exports = __webpack_public_path__ + "images/stickers/taco-sleeping@2x.9a51d634e8521dc0e19c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-sleeping@2x.png
// module id = bod4
// module chunks = 12